import { Chakra } from "@airhelp/react-ui-components";
import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

const { Box } = Chakra;

const OlList = ({ children, styles }: { children: ReactNode; styles: ChakraProps["sx"] }) => (
  <Box as="ol" sx={styles}>
    {children}
  </Box>
);

export default OlList;
